import instance from '../../../services/api';

export const adjustMenuPrices = (params) => (dispatch, getState) => {
  const {
    menu: { menu },
  } = getState();
  return instance.patch('/menu/adjust-prices', {
    menuId: menu._id,
    percent: params.percent,
    increase: params.increase,
    round: params.round,
  });
};
